import type { AsyncData } from "#app";
import type { NitroFetchOptions } from "nitropack";
import type { UseApiFetchOptions } from "@edco/apollo/dist/runtime/composables/useApiFetch";

export type TopicTag = {
  topicTagId: string;
  name: string;
  description: string;
  toolTip: string;
  draft: boolean;
};

export type OutcomeTag = {
  outcomeTagId: string;
  name: string;
  description: string;
  toolTip: string;
};

export type UserRoleTag = {
  userRoleTagId: string;
  name: string;
  description: string;
  toolTip: string;
  draft: boolean;
};

export type ContentTag = {
  contentTagId: string;
  name: string;
  description: string;
  toolTop: string;
}

export type NewTagResult = string | null;

export function $tagResource() {
  const dependencies = useFetchDependencies();

  function getTopics( abortSignal?: AbortSignal ) {
    const url = "/api/isn/tags/topics";
    const options: NitroFetchOptions<string> = {
      method: "GET",
      signal: abortSignal,
      headers: {
        Accept: "application/json",
      },
    };
    return $apiFetch<Array<TopicTag>>( url, options, dependencies );
  }

  function createNewTopic( name: string ) {
    const url = "/api/isn/tags/topics";
    const options: NitroFetchOptions<string> = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: { name },
    };
    return $apiFetch<NewTagResult>( url, options, dependencies );
  }

  function getOutcomes( abortSignal?: AbortSignal ) {
    const url = "/api/isn/tags/outcomes";
    const options: NitroFetchOptions<string> = {
      method: "GET",
      signal: abortSignal,
      headers: {
        Accept: "application/json",
      },
    };
    return $apiFetch<Array<OutcomeTag>>( url, options, dependencies );
  }

  function getUserRoles( abortSignal?: AbortSignal ) {
    const url = "/api/isn/tags/user-roles";
    const options: NitroFetchOptions<string> = {
      method: "GET",
      signal: abortSignal,
      headers: {
        Accept: "application/json",
      },
    };
    return $apiFetch<Array<UserRoleTag>>( url, options, dependencies );
  }

  function createNewUserRole( name: string ) {
    const url = "/api/isn/tags/user-roles";
    const options: NitroFetchOptions<string> = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: { name },
    };
    return $apiFetch<NewTagResult>( url, options, dependencies );
  }

  function getContentTags( abortSignal?: AbortSignal ) {
    const url = "/api/isn/tags/content";
    const options: NitroFetchOptions<string> = {
      method: "GET",
      signal: abortSignal,
      headers: {
        Accept: "application/json",
      },
    };
    return $apiFetch<Array<ContentTag>>( url, options, dependencies );
  }

  return {
    getTopics,
    createNewTopic,
    getOutcomes,
    getUserRoles,
    createNewUserRole,
    getContentTags,
  };
}

export function useTagResource() {
  function getTopics(): AsyncData<Array<TopicTag>, Error | null> {
    const url = "/api/isn/tags/topics";
    const options: UseApiFetchOptions<Array<TopicTag>> = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
    return useApiFetch<Array<TopicTag>>( url, options );
  }

  function getOutcomes(): AsyncData<Array<OutcomeTag>, Error | null> {
    const url = "/api/isn/tags/outcomes";
    const options: UseApiFetchOptions<Array<OutcomeTag>> = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
    return useApiFetch<Array<OutcomeTag>>( url, options );
  }

  function getUserRoles(): AsyncData<Array<UserRoleTag>, Error | null> {
    const url = "/api/isn/tags/user-roles";
    const options: UseApiFetchOptions<Array<UserRoleTag>> = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
    return useApiFetch<Array<UserRoleTag>>( url, options );
  }

  function getContentTags(): AsyncData<Array<ContentTag>, Error | null> {
    const url = "/api/isn/tags/content";
    const options: UseApiFetchOptions<Array<ContentTag>> = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
    return useApiFetch<Array<ContentTag>>( url, options );
  }

  return {
    getTopics,
    getOutcomes,
    getContentTags,
    getUserRoles,
  };
} 
